import { EventBus } from 'core-components/classes/events/Bus'
import { registerSharedDependency } from 'core-components/helpers/MFHelper'

class EventBusControllerClass {
  private eventBus: EventBus[] = []
  getEventBus(name: string, events: string[]) {
    if (!name) {
      console.error(`EventBusControllerClass::: try to get event bus without name`)
    }

    const existEventBus = this.eventBus.find((el) => {
      return el.getName() === name
    })
    if (existEventBus) {
      return existEventBus
    }
    const newEventBus = new EventBus(events, name)
    this.eventBus.push(newEventBus)
    return newEventBus
  }
}

export const EventBusController = registerSharedDependency<EventBusControllerClass>(
  'EventBusController',
  () => new EventBusControllerClass()
)
